<template>
  <div v-show="mask" class="mask">
    <div v-click-outside="handleHide" class="card">
      <div class="absolute top-4 right-4 w-4 h-4 cursor-pointer" @click.stop="handleHide">
        <img src="./assets/close.png" class="w-full h-full" alt="关闭" />
      </div>
      <div class="flex flex-col justify-center items-center">
        <div class="w-40 h-40">
          <img
            class="w-full h-full overflow-hidden rounded-full"
            :src="content.value[figureIndex].avatar"
            alt="头像"
          />
        </div>
        <span class="mt-6 w-full truncate text-xl font-normal text-center">{{
          content.value[figureIndex].name
        }}</span>
      </div>
      <div class="title">
        <img src="./assets/title.svg" class="h-3/5 mr-2" />
        <span class="title-text">{{ content.value[figureIndex].title }}</span>
      </div>
      <div class="content">
        <span class="content-text">{{ content.value[figureIndex].details || '暂无简介～' }}</span>
      </div>
      <div class="handle">
        <div
          :class="['previous', content.value.length > 1 ? '' : 'disabled']"
          @click="handlePrevious"
        ></div>
        <div
          :class="['next', content.value.length > 1 ? '' : 'disabled']"
          @click="handleNext"
        ></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import clickOutside from 'vue-click-outside';

@Component({
  directives: {
    clickOutside
  }
})
export default class Card extends Vue {
  @Prop({ type: Object }) content!: Content & { value: [] };
  mask = false;
  figureIndex = 0;

  open(index = 1) {
    this.mask = true;
    this.figureIndex = index;
  }

  handleHide() {
    this.mask = false;
  }

  handlePrevious() {
    this.figureIndex =
      (this.content.value.length + this.figureIndex - 1) % this.content.value.length;
  }
  handleNext() {
    this.figureIndex = (this.figureIndex + 1) % this.content.value.length;
  }
}
</script>

<style scoped>
.mask {
  @apply fixed top-0 ring-0 bottom-0 left-0 z-50 w-full h-full overflow-hidden select-none bg-opacity-50 bg-gray-900 flex justify-center items-center;
}

@screen sm {
  .card {
    @apply absolute rounded-md max-w-4xl w-4/5 max-h-full bg-no-repeat pt-16 pb-8 !important;
    background-size: 100% !important;
  }
}

.card {
  @apply absolute rounded-md w-5/6 max-h-full bg-no-repeat pt-12 pb-8;
  background-image: url(./assets/bg-image.svg), linear-gradient(to bottom, #fff, #fff);
  background-position: top;
  background-size: 160%;
}

.title {
  @apply mt-6 px-4 w-5/6 h-10 border rounded-md mx-auto flex items-center;
  border-color: var(--motif-100);
}

.title-text {
  @apply w-full truncate font-medium text-lg text-motif-500;
}

.content {
  @apply mt-4 p-4 w-5/6 max-h-36 border rounded-md mx-auto;
  border-color: var(--motif-100);
}

.content-text {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  line-clamp: 4;
}

.handle {
  @apply w-40 sm:w-48 mx-auto h-12 mt-12 flex items-center justify-between;
}

.handle > div {
  @apply relative w-12 h-12 rounded-full cursor-pointer border border-motif-500;
}

.handle > div.disabled {
  border-color: rgba(95, 44, 237, 0.14);
}

.handle > div::after {
  background-image: url('./assets/arrow.svg');
  background-repeat: no-repeat;
  content: ' ';
  @apply absolute top-1/2 left-1/2 w-4 h-4;
}

.handle > div.disabled::after {
  background-image: url('./assets/arrow-disabled.svg');
}

.handle > div::after:hover {
  border-color: #5f2ced;
}

.previous::after {
  transform: translate(-35%, -40%);
}

.next::after {
  transform: translate(-65%, -60%) rotate(180deg);
}
</style>
